import { AppBar, Button, Toolbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CourseTabList } from '@/constants/menu';
import { useCourses } from '@/providers';
import { useRoute } from '@/utils/client/route';

export default function FlashcardsBottomBar() {
  const { t } = useTranslation();
  const { goToRoute } = useRoute();
  const { selectedCourse } = useCourses();

  if (!selectedCourse) return null;

  const onChapterNavigation = () => {
    goToRoute('myCourseTabs', {
      courseSlug: selectedCourse.slug,
      tabId: CourseTabList.karteikarten,
    });
  };

  return (
    <AppBar
      position="fixed"
      color="default"
      sx={{
        top: 'auto',
        bottom: 0,
        '& > .MuiToolbar-root': {
          minHeight: 42,
          height: 50,
        },
      }}
      component="footer">
      <Toolbar
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          margin: '0 auto',
          paddingLeft: 15,
          paddingRight: 15,
          maxWidth: (theme) => theme.breakpoints.values.lg,
        }}>
        <Button variant="outlined" onClick={() => onChapterNavigation()}>
          {t('flashcard.flashcard.bottomBar.end')}
        </Button>
      </Toolbar>
    </AppBar>
  );
}
